(() => {
  const drawer = document.getElementById('headerDrawerMenu');
  const compactHeader = window.matchMedia('(max-width: 1199px)');
  if (!drawer) return;
  const closeBranch = (submenu) => {
    submenu.classList.remove('is-open');
    const safeId = window.CSS && CSS.escape ? CSS.escape(submenu.id) : submenu.id.replace(/"/g, '\\"');
    const controller = drawer.querySelector('.np-mobile-menu-toggler[aria-controls="' + safeId + '"]');
    if (controller) controller.setAttribute('aria-expanded', 'false');
    submenu.querySelectorAll('.np-mobile-submenu.is-open').forEach((child) => child.classList.remove('is-open'));
    submenu.querySelectorAll('.np-mobile-menu-toggler[aria-expanded="true"]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
  };
  drawer.addEventListener('click', (event) => {
    if (!compactHeader.matches) return;
    const button = event.target.closest('.np-mobile-menu-toggler');
    if (!button || !drawer.contains(button) || button.classList.contains('header-mobile__menu-item--back')) return;
    const targetId = button.getAttribute('aria-controls');
    const submenu = targetId ? document.getElementById(targetId) : null;
    if (!submenu) return;
    event.preventDefault();
    const willOpen = button.getAttribute('aria-expanded') !== 'true';
    const list = button.closest('ul');
    if (willOpen && list) {
      list.querySelectorAll(':scope > li > .np-mobile-submenu.is-open').forEach((openMenu) => {
        if (openMenu !== submenu) closeBranch(openMenu);
      });
    }
    button.setAttribute('aria-expanded', String(willOpen));
    submenu.classList.toggle('is-open', willOpen);
  });
  compactHeader.addEventListener('change', (event) => {
    if (!event.matches) drawer.querySelectorAll('.np-mobile-submenu.is-open').forEach(closeBranch);
  });
})();
